import axios from "axios";
import CryptoJS from "crypto-js";
import moment from "moment";
import { store } from "../Redux/store";
import Apiconfigs from "../ApiConfig/Apiconfig";

export const base64Key = "w2IKah2csuNE77fv1Zd8+jzxcJ2GYh3WO5UZMqfHj3Y=";

export function sortAddress(add) {
  const sortAdd = `${add.slice(0, 80)}...`;
  return sortAdd;
}

export function getSigner(library, account) {
  return library.getSigner(account).connectUnchecked();
}

export function getProviderOrSigner(library, account) {
  return account ? getSigner(library, account) : library;
}

// const csrftoken = getCookie("csrftoken");

// export const decryptData = (encryptedData) => {
//   const key = CryptoJS.enc.Base64.parse(base64Key);
//   const dataBytes = CryptoJS.enc.Base64.parse(encryptedData);
//   // first 16 bytes (4 words) used as IV
//   const iv = CryptoJS.lib.WordArray.create(dataBytes.words.slice(0, 4), 16);
//   // remaining bytes are the ciphertext
//   const ciphertext = CryptoJS.lib.WordArray.create(
//     dataBytes.words.slice(4),
//     dataBytes.sigBytes - 16
//   );

//   const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext });
//   const decryptedBytes = CryptoJS.AES.decrypt(cipherParams, key, {
//     iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   });
//   const decryptedText = CryptoJS.enc.Utf8.stringify(decryptedBytes);
//   return JSON.parse(decryptedText);
// };

// export const encryptData = (data) => {
//   const key = CryptoJS.enc.Base64.parse(base64Key);
//   const iv = CryptoJS.lib.WordArray.random(16);
//   const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
//     iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   });

//   const ciphertext = iv.concat(encrypted.ciphertext);
//   return CryptoJS.enc.Base64.stringify(ciphertext);
// };
export async function encryptData(data) {
  const encoder = new TextEncoder();

  // Derive same key using SHA-256(secret)

  const secret = base64Key; // same as Django SECRET_KEY but base64

  const secretBytes = Uint8Array.from(atob(secret), (c) => c.charCodeAt(0));

  const keyHash = await crypto.subtle.digest("SHA-256", secretBytes);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",

    keyHash,

    { name: "AES-GCM" },

    false,

    ["encrypt"]
  );

  const iv = crypto.getRandomValues(new Uint8Array(12)); // 12-byte IV for GCM

  const encoded = encoder.encode(JSON.stringify(data));

  const encrypted = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",

      iv: iv,
    },

    cryptoKey,

    encoded
  );

  // Combine IV + ciphertext

  const combined = new Uint8Array([...iv, ...new Uint8Array(encrypted)]);

  return btoa(String.fromCharCode(...combined));
}

export async function decryptData(encryptedBase64) {
  const encryptedBytes = Uint8Array.from(atob(encryptedBase64), (c) =>
    c.charCodeAt(0)
  );

  const iv = encryptedBytes.slice(0, 12);

  const ciphertext = encryptedBytes.slice(12);

  const secret = base64Key;

  const secretBytes = Uint8Array.from(atob(secret), (c) => c.charCodeAt(0));

  const keyHash = await crypto.subtle.digest("SHA-256", secretBytes);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",

    keyHash,

    { name: "AES-GCM" },

    false,

    ["decrypt"]
  );

  const decrypted = await crypto.subtle.decrypt(
    {
      name: "AES-GCM",

      iv: iv,
    },

    cryptoKey,

    ciphertext
  );

  const decoder = new TextDecoder();

  return JSON.parse(decoder.decode(decrypted));
}

export const getAPIdata = async ({
  endPoint,
  headers = {},
  withCredentials = true,
}) => {
  try {
    // const csrfToken = await csrf_token_Generate();
    let res;
    res = await axios({
      url: endPoint,
      method: "GET",
      headers: {},
      withCredentials,
    });

    if (res?.status === 200) {
      return await decryptData(res?.data);
    } else if (res?.data?.status === 400) {
      return false;
    } else if (res?.data?.status === 401) {
      return false;
    } else if (res?.data?.status === 500) {
      return false;
    } else {
      return false;
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      return error;
    } else if (error?.response?.status === 401) {
      return error;
    } else if (error?.response?.status === 500) {
      return error;
    } else {
      return error;
    }
  }
};

export const putAPIdata = async ({ params, data, endPoint, headers }) => {
  try {
    let res;

    res = await axios({
      url: endPoint,
      method: "PUT",
      params: params,
      data: data,
      headers: headers,
    })
      .then((res) => {
        if (res?.data?.status === 200) {
          return res?.data?.data;
        }
        if (res?.data?.status === 400) {
          return false;
        }
        if (res?.data?.status === 401) {
          return false;
        }
      })
      .catch((error) => {
        return false;
      });
    return res;
  } catch (error) {
    return false;
  }
};

const csrf_token_Generate = async (token) => {
  try {
    const res = await getAPIdata({
      endPoint: Apiconfigs.csrf_token,
    });
    if (res) {
      return res?.csrfToken;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const PostApiFunction = async ({
  endPoint,
  data,
  headers = {},
  withCredentials = true,
}) => {
  try {
    const csrfToken = await csrf_token_Generate();
    const res = await axios({
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "X-CSRFToken": csrfToken,
      },
      withCredentials,
    });

    if (res?.status === 200) {
      return decryptData(res?.data);
    } else {
      return false;
    }
  } catch (error) {
    return error;
  }
};

export const convertDateTime = (val) => {
  var tempDate = new Date(val);
  const toDateFormat = moment(tempDate).format("DD-MMM-yyyy hh:mm a");
  return toDateFormat;
};

export const localeFunction = (key) => {
  let str = store.getState("auth");
  let langCode = str.auth.langCode;

  switch (langCode) {
    case "en":
      return require(`../utils/lang/en`)[key];
    default:
      return require(`../utils/lang/hi`)[key];
  }
};

export const transformEmail = (email) => {
  return email.replace("@", "[at]").replace(".", "[dot]");
};
